import React from 'react';
import { Checkbox as SemanticRadio } from 'semantic-ui-react';

/*This component facilitates the customization of Radio*/

const Checkbox = (props) => {
  return <SemanticRadio {...props} />;
};

export default Checkbox;
